import { Navigate } from "react-router-dom";

const AuthMiddleware = ({ children }) => {
  const isAuthUser = localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
    
  if (!isAuthUser) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default AuthMiddleware;
